/**
 * @file 模态弹窗包装器
 * @author liudayu
 */



import { $document } from '../../utils/bom';
import { appendChild } from '../../utils/dom';
import React , { Component } from 'react';
import { render as domRender } from 'react-dom';


export interface IWrapperConfig {
    appendTo?: string;
    contentComponent?: React.ComponentClass<any> | React.FunctionComponent<any>;
}

function modalServiceWrapper<T extends IWrapperConfig>(
    dialogComponent: React.ComponentClass<T> | React.FunctionComponent<T>,
    hasChild = false,
) {
    const DialogComponent = dialogComponent;

    const func = (config: T) => {
        const hostEl = $document.createElement('div');
        hostEl.className = 'dialog-wrapper';
        appendChild(hostEl, config.appendTo || '');

        function close() {
            // const afterClose = destroy.bind(this, ...args);
            render({ ...(config as object), close, showDialog: false, afterClose: destroy });
        }

        function destroy(): any {
            if (hostEl.parentNode) {
                hostEl.parentNode.removeChild(hostEl);
            }
        }

        function render(props: any) {
            const ChildComponent = config.contentComponent;
            const childComponentProps = props.childProps;
            if (hasChild && ChildComponent) {
                const childProps = {
                    closeDialog: close,
                    ...childComponentProps,
                };
                domRender(
                    <DialogComponent {...props}>
                        <ChildComponent {...childProps}></ChildComponent>
                    </DialogComponent>
                , hostEl);
            } else {
                domRender(<DialogComponent  {...props} />, hostEl);
            }

        }

        render({ ...(config as object), showDialog: true, close });

        return {
            destroy: close,
        };
    };

    return func;
}

export default modalServiceWrapper;
